import { ArrowRightIcon } from 'lucide-react'

import { useOnboardingStep } from 'components/hooks/employer_onboarding/useOnboardingStep'
import { Button } from 'slab'

import { CenteredLayout } from '../CenteredLayout'

export const NextStepsPage = () => {
  const { navigateToPreviousStep, navigateToNextStep } = useOnboardingStep()

  return (
    <CenteredLayout displaySupportLink>
      <CenteredLayout.Header
        heading='Just a few more steps to get set up'
        subheading="After this, you'll be ready to invite your employees!"
      />
      <ol className='space-y-2 list-none'>
        <li className='bg-white rounded-2xl border border-gray-200 shadow p-4'>
          <div className='flex gap-4'>
            <div className='flex-shrink-0 w-5 h-5 bg-gradient-to-t from-thatch-500 to-thatch-600 rounded-full text-white flex items-center justify-center p-0.5 text-xs border-thatch-600 border-t-[0.5px] border-r-[0.5px] border-l-[0.5px] border-b-[1px] box-border shadow-[inset_0_1px_0_0.5px_rgba(255,255,255,0.25)]'>
              1
            </div>
            <div>
              <h3 className='body mb-2'>
                Configure your payroll deductions
              </h3>
              <p className='body-sm'>
                Set up your payroll schedule so that we can ensure that payroll deductions are correctly set up for your team
              </p>
            </div>
          </div>
        </li>

        <li className='bg-white rounded-2xl border border-gray-200 shadow p-4'>
          <div className='flex gap-4'>
            <div className='flex-shrink-0 w-5 h-5 bg-gradient-to-t from-thatch-500 to-thatch-600 rounded-full text-white flex items-center justify-center p-0.5 text-xs border-thatch-600 border-t-[0.5px] border-r-[0.5px] border-l-[0.5px] border-b-[1px] box-border shadow-[inset_0_1px_0_0.5px_rgba(255,255,255,0.25)]'>
              2
            </div>
            <div>
              <h3 className='body mb-2'>
                Confirm your company information
              </h3>
              <p className='body-sm'>
                Make sure we have the information we need about your business in order to stay compliant
              </p>
            </div>
          </div>
        </li>

        <li className='bg-white rounded-2xl border border-gray-200 shadow p-4'>
          <div className='flex gap-4'>
            <div className='flex-shrink-0 w-5 h-5 bg-gradient-to-t from-thatch-500 to-thatch-600 rounded-full text-white flex items-center justify-center p-0.5 text-xs border-thatch-600 border-t-[0.5px] border-r-[0.5px] border-l-[0.5px] border-b-[1px] box-border shadow-[inset_0_1px_0_0.5px_rgba(255,255,255,0.25)]'>
              3
            </div>
            <div>
              <h3 className='body mb-2'>
                Set up automatic payments
              </h3>
              <p className='body-sm'>
                We'll automatically debit your account each month for your employees' healthcare costs, so you'll never miss a bill
              </p>
            </div>
          </div>
        </li>
      </ol>
      <div className='mt-10 flex justify-end'>
        <CenteredLayout.Buttons align='right'>
          <Button variant='secondary' onClick={navigateToPreviousStep}>
            Back
          </Button>
          <Button
            variant='primary'
            onClick={navigateToNextStep}
            rightIcon={ArrowRightIcon}
          >
            Sounds good
          </Button>
        </CenteredLayout.Buttons>
      </div>
    </CenteredLayout>
  )
}
